import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';

export const Container = styled('div')({
  flexDirection: 'row',
  alignItems: 'center',
});

export const StyledChip = styled(Chip)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));
